import React, { useRef } from 'react'

import { Button, colors, Icon } from '@zet/design-system'
import { i18n } from '@zet/localization'

import { IBrandComsData } from '../../api/brands/types'

interface Props {
  eventPayload: any
  handlePress: (isSkipShareContentARNBottomsheet?: boolean) => void
  isLoading: boolean
  content?: IBrandComsData
  params: any
  customerData: any
  isWhatsappRef: ReturnType<typeof useRef<boolean>>
  isShouldShowWhatsappShare: boolean
}

export const NativeShareButton = (props: Props) => {
  const {
    eventPayload,
    handlePress,
    isLoading,
    content,
    params,
    customerData,
    isWhatsappRef,
    isShouldShowWhatsappShare,
  } = props

  const onNativeShareClick = () => {
    isWhatsappRef.current = false
    handlePress()
  }


  return (
    <Button
     intent={isShouldShowWhatsappShare ? '' : 'primary'}     
     outlined={isShouldShowWhatsappShare}
      size={'lg'}
      onPress={onNativeShareClick}
      className={`rounded ${
        isShouldShowWhatsappShare ? `border-primary-100 w-4` : 'w-full'
      }`}
      eventName={'click_action'}
      eventPayload={
        eventPayload || {
          item_name: params?.customerId
            ? 'brands_list_recommendation_share'
            : 'brands_list_share',
          brand_name: content?.name,
          brand_category: content?.subCategory,
          customer_id: params?.customerId,
        }
      }
      loading={isLoading}
      iconLeft={isShouldShowWhatsappShare ? <Icon type="Share" size={24} color={colors.primary[100]} /> : undefined}
    >
      {!isShouldShowWhatsappShare ? (customerData?.fullName 
        ? i18n.t('shareCardLink.shareCta', { name: customerData?.fullName })
        : 'Share'
      ) : ''}
    </Button>
  )
}
